<template>
  <li :class='{ on: selected }'>
    <router-link :to='link' class="link_gnb">{{ title }}</router-link>
    <div class="lnb_brand" v-if="hasSub">
      <ul class="list_lnb">
          <li v-for="item in arrSub" :key='item.menuId' :class='{on: selectedSubId === item.menuId }'>
            <router-link :to='item.link' class="link_lnb">{{ item.title }}</router-link>
          </li>
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    title: String,
    link: String,
    arrSub: Array,
    selected: Boolean,
    selectedSubId: String,
  },
  computed: {
    hasSub() {
      return this.arrSub && this.arrSub.length > 0;
    }
  }
}
</script>

<style scoped>
.gnb_brand .list_gnb:hover .on .link_gnb + .lnb_brand{display:none}
.gnb_brand .list_gnb:hover .on:hover .link_gnb + .lnb_brand{display:block}
.gnb_brand .list_gnb>li{float:left;position:relative}
.gnb_brand .list_gnb>li:nth-child(4) ~ li .lnb_brand{right:0}
.gnb_brand .list_gnb>li:nth-child(4) ~ li .list_lnb{text-align:right}
.gnb_brand .link_gnb{display:block;position:relative;padding:0 21px;font-weight:normal;font-family:'NotoSansKR_M', sans-serif;font-size:16px;line-height:80px;color:#222;letter-spacing:-.03em}
.gnb_brand .link_gnb:after{display:none;position:absolute;left:9px;right:9px;bottom:0;height:2px;background-color:#222;content:''}
/* .gnb_brand .list_gnb li:hover .link_gnb,
.gnb_brand .on .link_gnb{font-family:'NotoSansKR_B', sans-serif;color:#fff} */
.gnb_brand .list_gnb li:hover .link_gnb:after,
.gnb_brand .on .link_gnb:after{display:block}
.gnb_brand .list_gnb li:hover .lnb_brand,
.gnb_brand .on .link_gnb + .lnb_brand{display:block}
/* lnb */
.lnb_brand{display:none;position:absolute;width:765px}
.lnb_brand:after{position:fixed;top:70px;left:0;right:0;z-index:-1;height:47px;border-bottom:1px solid #e1e1e1;background-color:#FFFBED;text-align:center;content:''}
.lnb_brand .list_lnb{padding:0 18px 0 42px;font-size:0;text-align:left;vertical-align:top}
.lnb_brand .list_lnb li{display:inline-block;vertical-align:top}
.lnb_brand .list_lnb li + li{margin-left:56px}
.lnb_brand .list_lnb .on .link_lnb,
.lnb_brand .list_lnb .link_lnb:hover{font-family:'NotoSansKR_B', sans-serif;text-decoration:underline}
.lnb_brand .link_lnb{display:block;font-size:13px;line-height:48px;color:#555}
</style>
